import { render, staticRenderFns } from "./totalCupons.vue?vue&type=template&id=a5fe88a8&scoped=true"
import script from "./totalCupons.vue?vue&type=script&lang=js"
export * from "./totalCupons.vue?vue&type=script&lang=js"
import style0 from "./totalCupons.vue?vue&type=style&index=0&id=a5fe88a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fe88a8",
  null
  
)

export default component.exports